export enum TabsMenuOptionsRoutes {
  Dados = "dados",
  Endereco = "endereco",
  Contratos = "contratos",
  ContasBancarias = "contasBancarias",
  Impostos = "Impostos",
  Tributacao = "tributacao",
}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permission?: string;

}[] = [
    {
      label: "Dados Cadastrais",
      route: TabsMenuOptionsRoutes.Dados,
    },
    {
      label: "Endereço",
      route: TabsMenuOptionsRoutes.Endereco,
    },
    // {
    //   label: "Contratos",
    //   route: TabsMenuOptionsRoutes.Contratos,
    // },
    // {
    //   label: "Contas Bancárias",
    //   route: TabsMenuOptionsRoutes.ContasBancarias,
    // },
    {
      label: "Impostos",
      route: TabsMenuOptionsRoutes.Impostos,
    },

    {
      label: "Tributação",
      route: TabsMenuOptionsRoutes.Tributacao,
    },
  ];
